import React from "react";
import { StaticImage } from "gatsby-plugin-image";

export const BlueCircles1 = () => (
	<StaticImage loading="eager" src="./blue-circles-1.svg" alt="blue square" />
);
export const BlueCircles2 = () => (
	<StaticImage loading="eager" src="./blue-circles-2.svg" alt="blue square" />
);
export const BlueSquares0 = () => (
	<StaticImage loading="eager" src="./blue-square-0.svg" alt="blue square" />
);
export const BlueSquares1 = () => (
	<StaticImage loading="eager" src="./blue-squares-1.svg" alt="blue square" />
);
export const BlueSquares2 = () => (
	<StaticImage loading="eager" src="./blue-squares-2.svg" alt="blue square" />
);
export const BlueSquares3 = () => (
	<StaticImage loading="eager" src="./blue-squares-3.svg" alt="blue square" />
);
export const PinkCircles0 = () => (
	<StaticImage loading="eager" src="./pink-circles-0.svg" alt="pink circle" />
);
export const PinkCircles1 = () => (
	<StaticImage loading="eager" src="./pink-circles-1.svg" alt="pink circle" />
);
export const PinkCircles2 = () => (
	<StaticImage loading="eager" src="./pink-circles-2.svg" alt="pink circle" />
);
export const PinkCircles3 = () => (
	<StaticImage loading="eager" src="./pink-circles-3.svg" alt="pink circle" />
);
export const SmallPinkCircles0 = () => (
	<StaticImage
		loading="eager"
		src="./small-pink-circles-0.svg"
		alt="pink circle"
	/>
);
export const SmallPinkCircles1 = () => (
	<StaticImage
		loading="eager"
		src="./small-pink-circles-1.svg"
		alt="pink circle"
	/>
);
export const PinkOvals0 = () => (
	<StaticImage loading="eager" src="./pink-ovals-0.svg" alt="pink oval" />
);
export const PinkOvals1 = () => (
	<StaticImage loading="eager" src="./pink-ovals-1.svg" alt="pink oval" />
);
export const PinkOvals2 = () => (
	<StaticImage loading="eager" src="./pink-ovals-2.svg" alt="pink oval" />
);
export const PinkSquares0 = () => (
	<StaticImage
		loading="eager"
		src="./pink-squares-0.svg"
		alt="pink squares 0"
	/>
);
export const PinkSquares1 = () => (
	<StaticImage
		loading="eager"
		src="./pink-squares-1.svg"
		alt="pink square 1"
	/>
);
export const PinkSquares2 = () => (
	<StaticImage
		loading="eager"
		src="./pink-squares-2.svg"
		alt="pink squares 2"
	/>
);
export const PinkSquares3 = () => (
	<StaticImage
		loading="eager"
		src="./pink-squares-3.svg"
		alt="pink squares 3"
	/>
);

export const RamificationPattern = () => (
	<StaticImage
		loading="eager"
		src="./ramification-pattern.png"
		alt="ramification pattern"
	/>
);
export const RamificationPatternUp = () => (
	<StaticImage
		loading="eager"
		src="./ramification-pattern-up.png"
		alt="ramification pattern up"
	/>
);
export const RamificationPatternDown = () => (
	<StaticImage
		loading="eager"
		src="./ramification-pattern-down.png"
		alt="ramification pattern down 2"
	/>
);

export const EllipseTop = () => (
	<StaticImage
		loading="eager"
		src="./ellipse-top.png"
		alt="ellipse top half"
	/>
);


export const EllipseBottom = () => (
	<StaticImage
		loading="eager"
		src="./ellipse-bottom.png"
		alt="ellipse bottom half"
	/>
);


export const EllipseTop2 = () => (
	<StaticImage
		loading="eager"
		src="./ellipse-top-2.png"
		alt="ellipse top half 2"
	/>
);
